import React, { useContext, useState } from "react";
import styles from "../UsersModal/users.module.css";
import { RxCross1 } from "react-icons/rx";
import UserDetail from "../UsersModal/UserDetail";
import UserDocuments from "../UsersModal/UserDocuments";
import UserReferral from "../UsersModal/UserReferral";
import UserReview from "../UsersModal/UserReview";
import { UsersApi } from "../../../App/api/users.api";
import SelectDropdown from "../../Dropdown/SelectDropdown";
import CustomModal from "../../../custom/modal/customModal";
import CommonRejectTemplate from "../../CommonRejectTemplate";
import { approvalStatusApi } from "../../../App/api/multilevelApproval.api";
import ApprovalFlowManager from "../../../Pages/ApproveUnapprove/ApprovalFlowManager";
import { toast } from "react-toastify";
import LoaderContext from "../../loader";
import ApprovalStatus from "../../../Pages/ApproveUnapprove/ApprovalStatus";
const StoreModal = ({
  setToggleUsersDetails,
  toggleUsersDetails,
  approvalStatus,
  itemData,
  component,
  fetchAllData,
}) => {
  const [toggleContent, setToggleContent] = useState("Details");
  const [status, setStatus] = useState(itemData?.status);
  const [isRejectItemModalOpen, setIsRejectItemModalOpen] = useState(false);
  const [actionData, setActionData] = useState(null);
  const { handleLoading } = useContext(LoaderContext);
  const {
    approvalLevel,
    ApprovalFlow,
    matchedData,
    waitingForApproval,
    allApprovals,
    validateAndApprove,
  } = ApprovalFlowManager({
    component: "User",
    currentItems: itemData,
    approvalStatus,
  });

  const handleFilter = async (input, option) => {
    setActionData(option);

    const payload = {
      component_id: itemData?._id,
      component: "User",
      approvalFlow: allApprovals?.data?.[0]?._id,
      progress: {
        level: approvalLevel?.level,
        user: approvalLevel?.user,
        status: option,
        remarks: "",
      },
    };
    if (!validateAndApprove(payload)) {
      handleLoading(false);
      return;
    }

    try {
      if (option === "Approved") {
        ApprovalFlow?.length > 0
          ? await approvalStatusApi.updateApprovalStatus(
              payload,
              ApprovalFlow?.[0]?._id
            )
          : await approvalStatusApi.createApprovalStatus(payload);
        toast.success(`User ${actionData} by ${approvalLevel?.level}!`);

        fetchAllData();
      } else if (option === "Rejected") {
        setIsRejectItemModalOpen(true);
      } else if (option === "Business Off") {
        // Handle "Business Off" case
        console.log("Business Off logic here");
        ApprovalFlow?.length > 0
          ? await approvalStatusApi.updateApprovalStatus(
              payload,
              ApprovalFlow?.[0]?._id
            )
          : await approvalStatusApi.createApprovalStatus(payload);
        toast.success(`User ${actionData} by ${approvalLevel?.level}!`);

        fetchAllData();
      } else if (option === "Blocked") {
        // Handle "Blocked" case
        console.log("Blocked logic here");
        ApprovalFlow?.length > 0
          ? await approvalStatusApi.updateApprovalStatus(
              payload,
              ApprovalFlow?.[0]?._id
            )
          : await approvalStatusApi.createApprovalStatus(payload);
        toast.success(`User ${actionData} by ${approvalLevel?.level}!`);

        fetchAllData();
      }
    } catch (error) {
      console.log("error", error);
    }

    setStatus(option);
  };

  const handleClose = () => {
    setToggleUsersDetails(false);
  };
  if (toggleUsersDetails) {
    return (
      <>
        <div className={styles.main}>
          <div className={styles.container}>
            <div className="flex justify-between w-full  shadow-md  rounded-md items-center px-10 py-5 ">
              <div className="flex gap-10">
                <div>
                  <span
                    style={{
                      fontSize: "1.4rem",
                      textTransform: "capitalize",
                    }}
                  >
                    {itemData?.first_name}
                  </span>
                  <p className="capitalize bg-[var(--color--2)] rounded-md text-white w-fit px-2">
                    {itemData?.user_role?.name}
                  </p>
                </div>

                <SelectDropdown
                  inputName={status}
                  readOnly={
                    ApprovalFlow?.[0]?.progress?.status === "Approved" &&
                    "readOnly"
                  }
                  disabled={
                    ApprovalFlow?.[0]?.progress?.status === "Approved" &&
                    "disabled"
                  }
                  placeholder={itemData?.status || "Select Status"}
                  options={[
                    { name: "Approved", value: "Approved" },
                    { name: "Rejected", value: "Rejected" },
                    { name: "Business Off", value: "Business Off" },
                    { name: "Blocked", value: "Blocked" },
                  ]}
                  handleFilter={handleFilter}
                />
              </div>

              <RxCross1
                onClick={handleClose}
                text-2xl
                className="w-fit text-lg cursor-pointer  px-2 mt-2"
              />
            </div>
            {/* <hr /> */}
            <div style={{ display: "flex" }}>
              {["Details", "Documents", "Referral", "Review"].map((item) => (
                <hr
                  style={{
                    width: "25%",
                    borderTop:
                      item === toggleContent ? "5px solid " : "1px solid",
                    color:
                      item === toggleContent
                        ? "var(--color--2)"
                        : "var(--light-color3)",
                    borderRadius: "10px",
                    borderBottom: "none",
                    borderLeft: "none",
                    borderRight: "none",
                  }}
                />
              ))}
            </div>
            <div className={styles.content_list}>
              {["Details", "Documents", "Referral", "Review"].map((item) => (
                <span
                  onClick={() => setToggleContent(item)}
                  style={{
                    color:
                      item === toggleContent
                        ? "var(--color--2)"
                        : "var(--light-color3)",
                    cursor: "pointer",
                  }}
                >
                  {item}
                </span>
              ))}
            </div>
            {toggleContent === "Details" && (
              <UserDetail
                type={"store"}
                itemData={itemData}
                allApprovals={allApprovals}
                matchedData={matchedData}
                waitingForApproval={waitingForApproval}
              />
            )}
            {toggleContent === "Documents" && (
              <UserDocuments itemData={itemData} />
            )}
            {toggleContent === "Referral" && (
              <UserReferral itemData={itemData} />
            )}
            {toggleContent === "Review" && (
              <UserReview type={"store"} itemData={itemData} />
            )}
          </div>
        </div>
      
        <CustomModal
          isOpen={isRejectItemModalOpen}
          onClose={() => setIsRejectItemModalOpen(false)}
          title={`${actionData} Item`}
        >
          <CommonRejectTemplate
            data={itemData}
            actionData={actionData}
            getAllData={fetchAllData}
            endpoint={UsersApi.approveUser}
            closeModal={setIsRejectItemModalOpen}
            component={component}
            approvalStatus={approvalStatus}
          />
        </CustomModal>
      </>
    );
  }
};

export default StoreModal;
